/*************************************************************************************/
/************************************ NAME FIELD *************************************/
/*************************************************************************************/

(function () {

  // Number Cake is handled separately in numbercake.js
  if (window.location.pathname.includes('/products/number-cake')) return;

  const FIELD = '.show_name_only, .show_message_cont';
  const VALID = /^[A-Za-z!.]{1,8}$/;

  const ERROR_CLASS = 'name-field-error';

  /******************************** GET GLOBO OPTIONS ********************************/

  function getNameControls() {

    const selectors = [
      'input[name="dog-name"]',
      'input[name="_dog-name"]',
      'input[name="properties[dog-name]"]',
      'input[name="properties[_dog-name]"]'
    ];

    const known = Array.from(
      document.querySelectorAll(selectors.join(','))
    ).filter(input =>
      input.value === 'Name' ||
      input.value === 'No Name'
    );

    if (known.length) return known;

    // Fallback if Globo changes the radio input name
    const radios = Array.from(
      document.querySelectorAll(
        'input[type="radio"], input[type="checkbox"]'
      )
    );

    const noName = radios.find(input =>
      input.value.trim() === 'No Name'
    );

    if (!noName) return [];

    return radios.filter(input =>
      input.name === noName.name &&
      ['Name', 'No Name'].includes(input.value.trim())
    );
  }

  function getSelectedNameOption() {
    return getNameControls().find(input => input.checked) || null;
  }

  function getNameInput() {
    return document.querySelector(
      '.show_name_only input, ' +
      '.show_name_only textarea, ' +
      '.show_message_cont input, ' +
      '.show_message_cont textarea'
    );
  }

  /******************************** ERROR HANDLING ***********************************/

  function removeNameError() {
    document.querySelectorAll('.' + ERROR_CLASS)
      .forEach(error => error.remove());
  }

  function showNameError(input, message) {

    removeNameError();

    if (!input) return;

    const wrap = input.closest('.gpo-input-wrap') || input.parentElement;

    if (!wrap) return;

    const error = document.createElement('div');

    error.className = 'gpo-custom-error ' + ERROR_CLASS;
    error.textContent = message;

    wrap.insertAdjacentElement('afterend', error);
  }

  /******************************** INPUT SETTINGS **********************************/

  function configureNameInput(input) {

    if (!input) return;

    input.setAttribute('required', 'required');
    input.setAttribute('maxlength', '8');
    input.setAttribute('pattern', '^[A-Za-z!.]+$');
  }

  function disableNameInput(input) {

    if (!input) return;

    input.removeAttribute('required');
    input.removeAttribute('pattern');

    if (input.value !== '') {
      input.value = '';
    }
  }

  /******************************** SHOW / HIDE *************************************/

  function toggleNameField() {

    const controls = getNameControls();

    if (!controls.length) return;

    const selected = getSelectedNameOption();

    const show = !!selected && selected.value.trim() === 'Name';

    document.querySelectorAll(FIELD).forEach(function (block) {

      const input = block.querySelector('input, textarea');

      block.style.display = show ? 'block' : 'none';

      if (show) {
        configureNameInput(input);
      } else {
        disableNameInput(input);
        removeNameError();
      }

    });
  }

  /******************************** VALIDATION **************************************/

  function validateNameField() {

    const controls = getNameControls();

    if (!controls.length) return true;

    const selected = getSelectedNameOption();

    if (!selected || selected.value.trim() !== 'Name') {
      removeNameError();
      return true;
    }

    const input = getNameInput();

    if (!input) {
      console.warn('[Globo Name] Input field not found.');
      return false;
    }

    if (!input.value.trim()) {

      showNameError(input, 'Please enter your Dog Name.');

      input.focus();

      return false;
    }

    if (!VALID.test(input.value)) {

      showNameError(
        input,
        'Maximum 8 characters. Only letters, ! and . are allowed.'
      );

      input.focus();

      return false;
    }

    removeNameError();

    return true;
  }

  /******************************** INPUT FILTER ************************************/

  document.addEventListener('input', function (event) {

    const input = event.target;

    if (!input.matches('input, textarea')) return;

    if (!input.closest(FIELD)) return;

    if (!getNameControls().length) return;

    input.value = input.value
      .replace(/[^A-Za-z!.]/g, '')
      .substring(0, 8);

    if (input.value !== '') {
      removeNameError();
    }

  });

  /******************************** CHANGE EVENTS ***********************************/

  document.addEventListener('change', function (event) {

    if (getNameControls().includes(event.target)) {

      toggleNameField();

      setTimeout(toggleNameField, 100);
    }

  });

  document.addEventListener('click', function (event) {

    const control = event.target.closest(
      'label, input[type="radio"], input[type="checkbox"]'
    );

    if (!control) return;

    if (!getNameControls().length) return;

    setTimeout(toggleNameField, 100);

  });

  /******************************** ADD TO CART *************************************/

  document.addEventListener('click', function (event) {

    const button = event.target.closest(
      'button[type="submit"], ' +
      'button[name="add"], ' +
      '.product-form__submit'
    );

    if (!button) return;

    if (!getNameControls().length) return;

    if (!validateNameField()) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  }, true);

  document.addEventListener('submit', function (event) {

    if (!getNameControls().length) return;

    if (!validateNameField()) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  }, true);

  /******************************** INITIAL LOAD ************************************/

  function initializeNameField() {

    toggleNameField();

    setTimeout(toggleNameField, 300);
    setTimeout(toggleNameField, 800);
    setTimeout(toggleNameField, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNameField);
  } else {
    initializeNameField();
  }

  window.addEventListener('load', initializeNameField);

  window.addEventListener('pageshow', toggleNameField);

})();


/*************************************************************************************/
/*********************************** MESSAGE FIELD ***********************************/
/*************************************************************************************/

(function () {

  // Number Cake message is handled in numbercake.js
  if (window.location.pathname.includes('/products/number-cake')) return;

  const FIELD = '.show_message_only, .show_message_cont';

  const VALID = /^[A-Za-z0-9 &,.!'-]{1,30}$/;

  const ERROR_CLASS = 'message-field-error';

  /******************************** GET GLOBO OPTIONS ********************************/

  function getMessageControls() {

    const selectors = [
      'input[name="message"]',
      'input[name="_message"]',
      'input[name="properties[message]"]',
      'input[name="properties[_message]"]'
    ];

    const known = Array.from(
      document.querySelectorAll(selectors.join(','))
    ).filter(input =>
      input.value === 'No Message' ||
      input.value === 'Include Message'
    );

    if (known.length) return known;

    // Fallback for Globo-generated radio names
    const radios = Array.from(
      document.querySelectorAll(
        'input[type="radio"], input[type="checkbox"]'
      )
    );

    const noMessage = radios.find(input =>
      input.value.trim() === 'No Message'
    );

    if (!noMessage) return [];

    return radios.filter(input =>
      input.name === noMessage.name &&
      ['No Message', 'Include Message'].includes(input.value.trim())
    );
  }

  function getSelectedMessageOption() {
    return getMessageControls().find(input => input.checked) || null;
  }

  function getMessageInput() {
    return document.querySelector(
      '.show_message_only input, ' +
      '.show_message_only textarea, ' +
      '.show_message_cont input, ' +
      '.show_message_cont textarea'
    );
  }

  /******************************** ERROR HANDLING ***********************************/

  function removeMessageError() {
    document.querySelectorAll('.' + ERROR_CLASS)
      .forEach(error => error.remove());
  }

  function showMessageError(input, message) {

    removeMessageError();

    if (!input) return;

    const wrap = input.closest('.gpo-input-wrap') || input.parentElement;

    if (!wrap) return;

    const error = document.createElement('div');

    error.className = 'gpo-custom-error ' + ERROR_CLASS;
    error.textContent = message;

    wrap.insertAdjacentElement('afterend', error);
  }

  /******************************** INPUT SETTINGS **********************************/

  function configureMessageInput(input) {

    if (!input) return;

    input.setAttribute('required', 'required');
    input.setAttribute('maxlength', '30');
    input.setAttribute('pattern', "^[A-Za-z0-9 &,.!'-]+$");
  }

  function disableMessageInput(input) {

    if (!input) return;

    input.removeAttribute('required');
    input.removeAttribute('pattern');

    if (input.value !== '') {
      input.value = '';
    }
  }

  /******************************** SHOW / HIDE *************************************/

  function toggleMessageField() {

    const controls = getMessageControls();

    if (!controls.length) return;

    const selected = getSelectedMessageOption();

    const show = !!selected &&
      selected.value.trim() === 'Include Message';

    document.querySelectorAll(FIELD).forEach(function (block) {

      const input = block.querySelector('input, textarea');

      block.style.display = show ? 'block' : 'none';

      if (show) {
        configureMessageInput(input);
      } else {
        disableMessageInput(input);
        removeMessageError();
      }

    });
  }

  /******************************** VALIDATION **************************************/

  function validateMessageField() {

    const controls = getMessageControls();

    if (!controls.length) return true;

    const selected = getSelectedMessageOption();

    if (!selected || selected.value.trim() !== 'Include Message') {
      removeMessageError();
      return true;
    }

    const input = getMessageInput();

    if (!input) {
      console.warn('[Globo Message] Input field not found.');
      return false;
    }

    if (!input.value.trim()) {

      showMessageError(input, 'Please enter your Message.');

      input.focus();

      return false;
    }

    if (!VALID.test(input.value)) {

      showMessageError(
        input,
        'Maximum 30 characters. Only letters, numbers, spaces, &, comma, period, !, - and apostrophe are allowed.'
      );

      input.focus();

      return false;
    }

    removeMessageError();

    return true;
  }

  /******************************** INPUT FILTER ************************************/

  document.addEventListener('input', function (event) {

    const input = event.target;

    if (!input.matches('input, textarea')) return;

    if (!input.closest(FIELD)) return;

    if (!getMessageControls().length) return;

    input.value = input.value
      .replace(/[^A-Za-z0-9 &,.!'-]/g, '')
      .substring(0, 30);

    if (input.value.trim() !== '') {
      removeMessageError();
    }

  });

  /******************************** CHANGE EVENTS ***********************************/

  document.addEventListener('change', function (event) {

    if (getMessageControls().includes(event.target)) {

      toggleMessageField();

      setTimeout(toggleMessageField, 100);
    }

  });

  document.addEventListener('click', function (event) {

    const control = event.target.closest(
      'label, input[type="radio"], input[type="checkbox"]'
    );

    if (!control) return;

    if (!getMessageControls().length) return;

    setTimeout(toggleMessageField, 100);

  });

  /******************************** ADD TO CART *************************************/

  document.addEventListener('click', function (event) {

    const button = event.target.closest(
      'button[type="submit"], ' +
      'button[name="add"], ' +
      '.product-form__submit'
    );

    if (!button) return;

    if (!getMessageControls().length) return;

    if (!validateMessageField()) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  }, true);

  document.addEventListener('submit', function (event) {

    if (!getMessageControls().length) return;

    if (!validateMessageField()) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  }, true);

  /******************************** INITIAL LOAD ************************************/

  function initializeMessageField() {

    toggleMessageField();

    setTimeout(toggleMessageField, 300);
    setTimeout(toggleMessageField, 800);
    setTimeout(toggleMessageField, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMessageField);
  } else {
    initializeMessageField();
  }

  window.addEventListener('load', initializeMessageField);

  window.addEventListener('pageshow', toggleMessageField);

})();


/*************************************************************************************/
/******************************** SMALL MEDIUM FIELD *********************************/
/*************************************************************************************/

(function () {

  // Number Cake is handled separately
  if (window.location.pathname.includes('/products/number-cake')) return;

  const SMALL_VALID = /^[A-Za-z!.]{1,8}$/;
  const MEDIUM_VALID = /^[A-Za-z0-9 &,.!'-]{1,30}$/;

  const ERROR_CLASS = 'small-medium-field-error';

  /******************************** GET INCLUDE OPTIONS ******************************/

  function getIncludeControls() {

    const selectors = [
      'input[name="name-message"]',
      'input[name="_name-message"]',
      'input[name="properties[name-message]"]',
      'input[name="properties[_name-message]"]'
    ];

    const known = Array.from(
      document.querySelectorAll(selectors.join(','))
    ).filter(input =>
      input.value === 'Include' ||
      input.value === 'Not Include'
    );

    if (known.length) return known;

    // Fallback for different Globo-generated radio names
    const radios = Array.from(
      document.querySelectorAll(
        'input[type="radio"], input[type="checkbox"]'
      )
    );

    const notInclude = radios.find(input =>
      input.value.trim() === 'Not Include'
    );

    if (!notInclude) return [];

    return radios.filter(input =>
      input.name === notInclude.name &&
      ['Include', 'Not Include'].includes(input.value.trim())
    );
  }

  function getSelectedIncludeOption() {
    return getIncludeControls().find(input => input.checked) || null;
  }

  function isIncludeSelected() {

    const selected = getSelectedIncludeOption();

    return !!selected && selected.value.trim() === 'Include';
  }

  /******************************** GET SIZE *****************************************/

  function getSelectedSize() {

    const checkedRadios = document.querySelectorAll(
      'input[type="radio"]:checked'
    );

    for (const input of checkedRadios) {

      const value = String(input.value || '').trim().toLowerCase();

      if (value === 'small') return 'Small';

      if (value === 'medium') return 'Medium';
    }

    return '';
  }

  /******************************** GET INPUTS ***************************************/

  function getSmallInput() {
    return document.querySelector(
      '.show_name input, .show_name textarea'
    );
  }

  function getMediumInput() {
    return document.querySelector(
      '.show_message input, .show_message textarea'
    );
  }

  function getActiveInput() {

    if (!isIncludeSelected()) return null;

    const size = getSelectedSize();

    if (size === 'Small') {
      return getSmallInput();
    }

    if (size === 'Medium') {
      return getMediumInput();
    }

    return null;
  }

  /******************************** ERROR HANDLING ***********************************/

  function removeError() {

    document.querySelectorAll('.' + ERROR_CLASS)
      .forEach(error => error.remove());
  }

  function showError(input, message) {

    removeError();

    if (!input) return;

    const wrap = input.closest('.gpo-input-wrap') || input.parentElement;

    if (!wrap) return;

    const error = document.createElement('div');

    error.className = 'gpo-custom-error ' + ERROR_CLASS;
    error.textContent = message;

    wrap.insertAdjacentElement('afterend', error);
  }

  /******************************** INPUT SETTINGS **********************************/

  function configureSmallInput(input) {

    if (!input) return;

    input.setAttribute('required', 'required');
    input.setAttribute('maxlength', '8');
    input.setAttribute('pattern', '^[A-Za-z!.]+$');
  }

  function configureMediumInput(input) {

    if (!input) return;

    input.setAttribute('required', 'required');
    input.setAttribute('maxlength', '30');
    input.setAttribute('pattern', "^[A-Za-z0-9 &,.!'-]+$");
  }

  function disableInput(input) {

    if (!input) return;

    input.removeAttribute('required');
    input.removeAttribute('pattern');

    if (input.value !== '') {
      input.value = '';
    }
  }

  /******************************** SHOW / HIDE *************************************/

  function toggleSmallMediumFields() {

    const controls = getIncludeControls();

    if (!controls.length) return;

    const size = getSelectedSize();

    const include = isIncludeSelected();

    // SMALL CAKE NAME FIELD
    document.querySelectorAll('.show_name').forEach(function (block) {

      const input = block.querySelector('input, textarea');

      const show = include && size === 'Small';

      block.style.display = show ? 'block' : 'none';

      if (show) {
        configureSmallInput(input);
      } else {
        disableInput(input);
      }
    });

    // MEDIUM CAKE MESSAGE FIELD
    document.querySelectorAll('.show_message').forEach(function (block) {

      const input = block.querySelector('input, textarea');

      const show = include && size === 'Medium';

      block.style.display = show ? 'block' : 'none';

      if (show) {
        configureMediumInput(input);
      } else {
        disableInput(input);
      }
    });

    removeError();
  }

  /******************************** VALIDATION **************************************/

  function validateSmallMediumField() {

    const controls = getIncludeControls();

    if (!controls.length) return true;

    if (!isIncludeSelected()) {
      removeError();
      return true;
    }

    const size = getSelectedSize();

    if (size !== 'Small' && size !== 'Medium') {
      return true;
    }

    const input = getActiveInput();

    if (!input) {
      console.warn('[Globo Small Medium] Input field not found.');
      return false;
    }

    if (!input.value.trim()) {

      showError(
        input,
        size === 'Small'
          ? 'Please enter your Dog Name.'
          : 'Please enter your Message.'
      );

      input.focus();

      return false;
    }

    if (size === 'Small' && !SMALL_VALID.test(input.value)) {

      showError(
        input,
        'Maximum 8 characters. Only letters, ! and . are allowed.'
      );

      input.focus();

      return false;
    }

    if (size === 'Medium' && !MEDIUM_VALID.test(input.value)) {

      showError(
        input,
        'Maximum 30 characters. Only letters, numbers, spaces, &, comma, period, !, - and apostrophe are allowed.'
      );

      input.focus();

      return false;
    }

    removeError();

    return true;
  }

  /******************************** INPUT FILTER ************************************/

  document.addEventListener('input', function (event) {

    const input = event.target;

    if (!input.matches('input, textarea')) return;

    // SMALL NAME
    if (input.closest('.show_name')) {

      input.value = input.value
        .replace(/[^A-Za-z!.]/g, '')
        .substring(0, 8);

      if (input.value !== '') {
        removeError();
      }

      return;
    }

    // MEDIUM MESSAGE
    if (input.closest('.show_message')) {

      input.value = input.value
        .replace(/[^A-Za-z0-9 &,.!'-]/g, '')
        .substring(0, 30);

      if (input.value.trim() !== '') {
        removeError();
      }
    }

  });

  /******************************** CHANGE EVENTS ***********************************/

  document.addEventListener('change', function (event) {

    if (
      getIncludeControls().includes(event.target) ||
      event.target.matches('input[type="radio"]') ||
      event.target.matches('input[type="checkbox"]') ||
      event.target.matches('select')
    ) {

      setTimeout(toggleSmallMediumFields, 100);
    }

  });

  document.addEventListener('click', function (event) {

    const control = event.target.closest(
      'label, input[type="radio"], input[type="checkbox"]'
    );

    if (!control) return;

    if (!getIncludeControls().length) return;

    setTimeout(toggleSmallMediumFields, 150);

  });

  /******************************** ADD TO CART *************************************/

  document.addEventListener('click', function (event) {

    const button = event.target.closest(
      'button[type="submit"], ' +
      'button[name="add"], ' +
      '.product-form__submit'
    );

    if (!button) return;

    if (!getIncludeControls().length) return;

    if (!validateSmallMediumField()) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  }, true);

  document.addEventListener('submit', function (event) {

    if (!getIncludeControls().length) return;

    if (!validateSmallMediumField()) {

      event.preventDefault();
      event.stopImmediatePropagation();

      return false;
    }

  }, true);

  /******************************** INITIAL LOAD ************************************/

  function initializeSmallMedium() {

    toggleSmallMediumFields();

    setTimeout(toggleSmallMediumFields, 300);
    setTimeout(toggleSmallMediumFields, 800);
    setTimeout(toggleSmallMediumFields, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSmallMedium);
  } else {
    initializeSmallMedium();
  }

  window.addEventListener('load', initializeSmallMedium);

  window.addEventListener('pageshow', toggleSmallMediumFields);

})();